import { useSettingMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { create } from "zustand";

interface ExpandingOffer {
  isPreQualifiedForExpandingOffer: boolean;
  isPreApprovedForExpandingOffer: boolean;
  setExpandingOffer: (retailer: Partial<IRetailer>) => void;
}

export const useZustandExpandingOffer = create<ExpandingOffer>((set) => ({
  isPreQualifiedForExpandingOffer: false,
  isPreApprovedForExpandingOffer: false,
  setExpandingOffer: (retailer) => {
    set({
      isPreQualifiedForExpandingOffer:
        retailer?.is_pre_qualified_for_expanding_offer ?? false,
      isPreApprovedForExpandingOffer:
        retailer?.is_pre_approved_for_expanding_offer ?? false,
    });
  },
}));

const useExpandingOfferControl = () => {
  const { isPreQualifiedForExpandingOffer, isPreApprovedForExpandingOffer } =
    useRetailerStore([
      "isPreQualifiedForExpandingOffer",
      "isPreApprovedForExpandingOffer",
    ]);
  return {
    isPreQualifiedForExpandingOffer,
    isPreApprovedForExpandingOffer,
  };
};

export const useExpandingOffer = () => {
  const shouldUseHooksMigration = useSettingMigrateRetailerStore();
  if (shouldUseHooksMigration) {
    // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    return useZustandExpandingOffer();
  }
  // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
  return useExpandingOfferControl();
};
